<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="menu-bar">
    <h3>Menu</h3>
    <span class="menu-item" @click="changeTool('pen')">
      <img src="https://cdn.exploreve.fr/content/drawing/icone_brush.svg" alt />
    </span>
    <span class="menu-item" @click="changeTool('eraser')">
      <img src="https://cdn.exploreve.fr/content/drawing/icone_eraser.svg" alt />
    </span>
    <span class="menu-item" @click="changeTool('fill')">
      <img src="https://cdn.exploreve.fr/content/drawing/icone_fill.svg" alt />
    </span>
    <span class="menu-item" @click="clear">
      <img src="https://cdn.exploreve.fr/content/drawing/IconeCroix.svg" alt />
    </span>
    <span class="menu-item" @click="toggleGrid">
      <img src="https://cdn.exploreve.fr/content/drawing/icone_grid.svg" alt />
    </span>
    <div class="menu-item color-menu">
      <span class="color-title tooltips">
        <img src="https://cdn.exploreve.fr/content/drawing/icone_pallete.svg" alt />
      </span>
      <Compact :value="color" @input="changeColor" />
    </div>
  </div>
</template>
<script>
import { Compact } from "vue-color";
export default {
  data: () => {
    return {
      tool: "pen",
      color: "#194D33"
    };
  },
  methods: {
    clear() {
      if (!confirm("Voulez-vous tout effacer ?")) return;
      this.$emit("clear");
    },
    changeTool(tool) {
      this.tool = tool;
      this.$emit("color", this.color);
      this.$emit("tool", tool);
    },
    changeColor(color) {
      this.color = color.hex;
      this.$emit("color", color.hex);
    },
    toggleGrid() {
      this.$emit("grid");
    }
  },
  computed: {},
  components: { Compact }
};
</script>
<style scoped lang="scss">
.menu-bar {
  z-index: 998;
  display: flex;
  flex-direction: column;
  background-color: #eecea1;
  opacity: 0.3;
  border-radius: 24px;
  padding: 12px;
  transition: 0.3s all ease-in-out;
  & h3 {
    font-size: 1.2rem;
  }
  &:hover {
    opacity: 0.9;
  }
  & .menu-item {
    color: #5e2a57;
    transition: 0.3s all ease-in-out;
    width: 32px;
    margin: 0 auto;
    &:hover {
      color: #da9ad1;
      cursor: pointer;
    }
  }
}
div.color-menu {
  position: relative;
  display: inline;
  div {
    position: absolute;
    width: 150px;
    color: #ffffff;
    background: #000000;
    height: 150px;
    line-height: 30px;
    text-align: center;
    visibility: hidden;
    border-radius: 6px;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 100%;
      margin-top: -8px;
      width: 0;
      height: 0;
      border-left: 8px solid #000000;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
    }
  }
  &:hover div {
    visibility: visible;
    right: 60%;
    top: -165%;
    margin-top: -15px;
    margin-right: 15px;
    z-index: 999;
  }
}
</style>
